import { cn } from "@/lib/utils";

type Tone = "moss" | "amber" | "berry" | "indigo" | "terracotta" | "neutral";

const toneMap: Record<Tone, string> = {
  moss: "bg-[hsl(var(--moss)/0.10)] text-moss border-[hsl(var(--moss)/0.25)]",
  amber: "bg-[hsl(var(--amber)/0.10)] text-amber-rf border-[hsl(var(--amber)/0.25)]",
  berry: "bg-[hsl(var(--berry)/0.10)] text-berry border-[hsl(var(--berry)/0.25)]",
  indigo: "bg-[hsl(var(--indigo)/0.10)] text-indigo-rf border-[hsl(var(--indigo)/0.25)]",
  terracotta: "bg-[hsl(var(--accent)/0.10)] text-accent border-[hsl(var(--accent)/0.25)]",
  neutral: "bg-canvas-2 text-ink-2 border-line",
};

export function Pill({
  children,
  tone = "neutral",
  className,
}: {
  children: React.ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium tracking-wide uppercase",
        toneMap[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
